export default "/048cb1f2b29308e18768c65cfd51e426596a830c/5ba84b7c5997e2a9223c26a23a6fa17e.svg";